import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OSK_GUIDE_PATH, OskGuideService } from '../../../shared/services/osk-guide.service';

/**
 * "Instrukcja" button in the fas-admin top bar, left of the account button; OskGuideTopBarService puts it
 * there for the OSK owner. A red "1" stays on it until the guide page is opened.
 */
@Component({
  selector: 'app-osk-guide-button',
  standalone: true,
  template: `
    <button
      type="button"
      class="primary-menu-btn osk-guide-button"
      data-clarity-unmask="true"
      [attr.aria-label]="guide.unread() ? 'Instrukcja panelu – nowa, nieprzeczytana' : 'Instrukcja panelu'"
      title="Instrukcja panelu"
      (click)="open()"
    >
      <!-- Not spans: on a phone the panel clips every span of the top bar buttons (mobile.scss), the badge too. -->
      <em class="osk-guide-button__icon">
        <i class="pi pi-book"></i>
        @if (guide.unread()) {
          <b class="osk-guide-button__badge" aria-hidden="true">1</b>
        }
      </em>
      <span class="osk-guide-button__label">Instrukcja</span>
    </button>
  `,
  styleUrl: './osk-guide-button.component.scss',
})
export class OskGuideButtonComponent {
  readonly guide = inject(OskGuideService);
  private readonly router = inject(Router);

  open(): void {
    this.router.navigate(['/', OSK_GUIDE_PATH]);
  }
}
